import { useCallback, useEffect, useState } from 'react';
import { Alert, Linking, Platform } from 'react-native';
import noop from 'lodash/noop';
import { useActionSheet } from 'hooks/useActionSheet';
import { openEmailApp } from 'utils/packages/intentLauncher';
const EMAIL_APPS = [
    {
        name: 'Mail',
        urlScheme: 'message://test',
    },
    {
        name: 'Gmail',
        urlScheme: 'googlegmail://?',
    },
    {
        name: 'Outlook',
        urlScheme: 'ms-outlook://test',
    },
    {
        name: 'Airmail',
        urlScheme: 'airmail://test',
    },
    {
        name: 'Yahoo Mail',
        urlScheme: 'ymail://test',
    },
    {
        name: 'Spark',
        urlScheme: 'readdle-spark://test',
    },
    {
        name: 'Superhuman',
        urlScheme: 'superhuman://test',
    },
];
const useOpenEmailApp = () => {
    const actionSheet = useActionSheet();
    const [emailApps, setEmailApps] = useState([]);
    useEffect(() => {
        async function calculateEmailOptions() {
            if (Platform.OS === 'ios') {
                const promises = [];
                for (let i = 0; i < EMAIL_APPS.length; i++) {
                    const app = EMAIL_APPS[i];
                    try {
                        promises.push(Linking.canOpenURL(app.urlScheme).then((canOpen) => ({
                            canOpen,
                            app,
                        })));
                    }
                    catch {
                        // ignore
                    }
                }
                const results = await Promise.all(promises);
                setEmailApps(results.filter((app) => app.canOpen).map((app) => app.app));
            }
        }
        calculateEmailOptions();
    }, []);
    const onPressIndex = useCallback(async (idx) => {
        if (idx === undefined || idx >= emailApps.length) {
            return;
        }
        const { urlScheme, name } = emailApps[idx];
        const error = () => Alert.alert('Error', `Could not open ${name}`);
        if (await Linking.canOpenURL(urlScheme)) {
            try {
                await Linking.openURL(urlScheme);
            }
            catch {
                error();
            }
        }
        else {
            error();
        }
    }, [emailApps]);
    const onPressOpenEmail = useCallback(() => {
        if (Platform.OS === 'ios') {
            actionSheet.showActionSheetWithOptions({
                options: emailApps.map((app) => app.name).concat('Cancel'),
                cancelButtonIndex: emailApps.length,
            }, onPressIndex);
        }
        else if (Platform.OS === 'android') {
            openEmailApp()
                .then((opened) => {
                if (!opened) {
                    Alert.alert('No email app found', undefined, [{ text: 'Okay' }]);
                }
            })
                .catch(noop);
        }
    }, [actionSheet, emailApps, onPressIndex]);
    return [onPressOpenEmail, Platform.OS === 'android' || emailApps.length > 0];
};
export default useOpenEmailApp;
